import React from "react";

const education = [
  {
    school: "Bahçeşehir University",
    program: "Computer Engineering · 100% English",
    location: "Istanbul, Turkey",
    date: "2021 – 2026",
    // gpa yok, drop year yok
  },
];

export default function Education() {
  return (
    <section id="education" className="w-full bg-[#0d0d0d]  py-20">
      {/* Header */}
      <div className="px-6 md:px-10">
        <h2 className="text-5xl md:text-6xl font-semibold tracking-tight text-white/90">
          Education
        </h2>
      </div>

      {/* Full-width card (Experience style) */}
      <div className="mt-10 px-6 md:px-10">
        {education.map((e) => (
          <div
            key={e.school}
            className="w-full overflow-hidden rounded-[32px] bg-white/[0.03]"
          >
            <div className="px-7 py-7 md:px-10 md:py-9">
              {/* top row */}
              <div className="flex flex-col gap-3 md:flex-row md:items-start md:justify-between">
                <div>
                  <div className="text-[11px] font-semibold tracking-[0.22em] uppercase text-neutral-500">
                    Education
                  </div>

                  <h3 className="mt-2 text-3xl md:text-4xl font-semibold tracking-tight text-neutral-200">
                    {e.school}
                  </h3>

                  <div className="mt-3 text-[15px] md:text-base font-medium text-neutral-400">
                    {e.program}
                  </div>

                  <div className="mt-1 text-[14px] md:text-[15px] text-neutral-500">
                    {e.location}
                  </div>
                </div>

                {/* date pill */}
                <div className="md:pt-1">
                  <span className="inline-flex rounded-full bg-white/5 px-4 py-2 text-sm font-medium text-neutral-300">
                    {e.date}
                  </span>
                </div>
              </div>

             
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
